import { ArrowLeft, ArrowRight } from "lucide-react";
import React from "react";

/* Dummy hero background (free safe image) */
const DUMMY_BG =
  "https://i.postimg.cc/t4YRDRbd/6390.jpg";

export default function HeroCard28() {
  return (
    <>
      <div className="ds-wrapper">

       

        {/* HERO SECTION */}
        <section className="ds-hero">

          <div
            className="ds-hero-bg"
            style={{ backgroundImage: `url('${DUMMY_BG}')` }}
          />
          <div className="ds-hero-overlay" />

          <div className="ds-hero-content">
            <h1>DO YOU WANT TO<br />LEARN HOW TO DRIVE?</h1>

            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore.
            </p>

            <a href="#" className="ds-hero-cta"><ArrowLeft className="ds-hero-cta-inn" size={20}/> BOOK A CLASS</a>
          </div>

          {/* PREV / NEXT BUTTONS */}
          <button className="ds-prev"><ArrowLeft className="ds-hero-pn-inn" size={20}/><span className="ds-hero-pn-inn-text"> PREV</span></button>
          <button className="ds-next"><span className="ds-hero-pn-inn-text">NEXT</span> <ArrowRight className="ds-hero-pn-inn" size={20}/></button>

          {/* Slider dot-hc28s (pure css animated) */}
          <div className="ds-dot-hc28s">
            <span className="dot-hc28 d1"></span>
            <span className="dot-hc28 d2"></span>
            <span className="dot-hc28 d3"></span>
          </div>

        </section>

        {/* BOTTOM INFO STRIP */}
        <div className="ds-info-strip">
          <div className="info-item">📞 123-456-7</div>
          <div className="info-item">✉ drivingschool@gmail.com</div>
        </div>
      </div>

      <style>{`
/* ============= RESET ============= */
.ds-wrapper {
  font-family: 'Inter', sans-serif;
  color: #fff;
  overflow-x: hidden;
}

/* ============= TOP ALERT BAR ============= */
.ds-alert {
  background: #111;
  color: #99cc99;
  text-align: center;
  padding: 8px;
  font-size: 0.85rem;
  font-weight: 600;
}

/* ============= HEADER ============= */
.ds-header {
  background: white;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.ds-header-inner {
  width: 92%;
  margin: auto;
  display: flex;
  align-items: center;
  gap: 20px;
}

.ds-logo {
  font-weight: 900;
  color: #2d3436;
  font-size: 1.5rem;
  white-space: nowrap;
}

.ds-nav {
  display: flex;
  gap: 18px;
  flex: 1;
}
.ds-nav a {
  text-decoration: none;
  color: #333;
  font-weight: 600;
}
.ds-nav a:hover {
  color: #99cc99;
}

.ds-search-box {
  display: flex;
  align-items: center;
  background: #111;
  border-radius: 4px;
  overflow: hidden;
}

.ds-search-box input {
  background: transparent;
  border: none;
  outline: none;
  color: #ddd;
  padding: 10px 14px;
  width: 200px;
}

.ds-search-btn {
  background: #99cc99;
  border: none;
  padding: 10px 14px;
  cursor: pointer;
  color: black;
  font-weight: 700;
}

.ds-book-btn {
  background: #99cc99;
  border: none;
  padding: 10px 18px;
  cursor: pointer;
  margin-right: 6px;
  font-weight: 700;
}

.ds-buy {
  background: #99cc99;
  border: none;
  padding: 10px 18px;
  cursor: pointer;
  font-weight: 700;
}

/* ============= HERO ============= */
.ds-hero {
  position: relative;
  min-height: 80vh;
  display: flex;
  align-items: center;
  padding-left: 6%;
  padding-right: 6%;
}

.ds-hero-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  transform: scale(1.03);
}

.ds-hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1;
}

.ds-hero-content {
  position: relative;
  z-index: 3;
  max-width: 540px;
}

.ds-hero-content h1 {
  font-size: 2.8rem;
  line-height: 1.2;
  margin-bottom: 14px;
  font-weight: 900;
}

.ds-hero-content p {
  opacity: 0.9;
  margin-bottom: 20px;
}

.ds-hero-cta {
 width:180px;background: rgba(153, 204, 153, 0.21);
  color: #ffffff;position:relative;
  
  text-decoration: none;
  font-weight: 900;
  border-radius: 4px;border:2px solid  #99cc99;
  display: flex;justify-content:left;gap:10px;align-items:center;
}.ds-hero-cta-inn {
  background: rgba(153, 204, 153, 1);width:30px;
  color: #111;
  padding: 14px 12px;
  text-decoration: none;
  font-weight: 900;
  
}.ds-hero-pn-inn {
  background: #99cc99;width:30px;
  color: #111;
  padding: 8px 12px;
  text-decoration: none;
  font-weight: 900;
  
}
  .ds-hero-pn-inn-text{padding:10px;}
  
  .ds-hero-cta::after {
    content: "";
    position: absolute;
    z-index:999;top:0px;
    left: 100%;
    margin-left: 0px;
    border-width: 24px;
    border-style: solid;
    border-color:  transparent transparent   transparent #99cc99;
  }

/* PREV / NEXT */
.ds-prev, .ds-next { display:flex;justify-content:space-between;gap:10px;align-items:center;
  position: absolute;width:110px;
  bottom: 30px;margin:0px;padding:0px;
  background: rgba(153, 204, 153, 0.31);
  color: #111;
  
  border: none;
  font-weight: 700;
  cursor: pointer;
  z-index: 4;
}
.ds-prev { left: 6%; }
.ds-next { right: 6%; }
 .ds-prev::after {
    content: "";
    position: absolute;
    z-index:999;top:0px;
    left: 15.5%;
    margin-left: 0px;
    border-width: 18px;
    border-style: solid;
    border-color:  transparent  rgba(97, 116, 130, 1) transparent   transparent;
  }.ds-next::after {
    content: "";
    position: absolute;
    z-index:999;top:0px;
    right: 15.5%;
    margin-left: 0px;
    border-width: 18px;
    border-style: solid;
    border-color:  transparent   transparent   transparent rgba(97, 116, 130, 1) ;
  }
/* ============= DOTS ============= */
.ds-dot-hc28s {
  position: absolute;
  left: 50%;
  bottom: 34px;
  display: flex;
  gap: 10px;
  transform: translateX(-50%);
  z-index: 4;
}

.dot-hc28 {
  width: 12px; height: 12px;
  border-radius: 50%;
  background: #fff;
  opacity: 0.5;
}

/* Cycling animation */
.d1 { animation: dot-hc28Anim 9s infinite; }
.d2 { animation: dot-hc28Anim 9s infinite 3s; }
.d3 { animation: dot-hc28Anim 9s infinite 6s; }

@keyframes dot-hc28Anim {
  0%, 20% { opacity: 1; transform: scale(1.2); }
  40%, 100% { opacity: 0.5; transform: scale(1); }
}

/* ============= INFO STRIP ============= */
.ds-info-strip {
  display: flex;
  background: #99cc99;
  padding: 18px 6%;
  gap: 40px;
  font-weight: 700;
  color: #000;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
      `}</style>
    </>
  );
}
